<template>
  <section class="payments-monthly" aria-labelledby="payments-monthly-title">
    <header class="payments-monthly__header">
      <DsChip label="Tu mensualidad" variant="orange" />

      <DsTextSplit
        id="payments-monthly-title"
        as="h3"
        base="Claridad total"
        highlight="sobre tus fechas"
        base-color="var(--ds-purple-900)"
        highlight-color="var(--ds-purple-400)"
        class="payments-monthly__title"
      />

      <DsText as="body3" class="payments-monthly__intro">
        Pagar a tiempo te ayuda a mantener tus beneficios activos durante todo
        el plazo.
      </DsText>
    </header>

    <div class="payments-monthly__cards">
      <PaymentsMonthlyCard
        v-for="card in cards"
        :key="card.id"
        :icon-src="card.iconSrc"
        :title="card.title"
        :mobile-description="card.mobileDescription"
        :tablet-description="card.tabletDescription"
        :desktop-description="card.desktopDescription"
      />
    </div>

    <div class="payments-monthly__note">
      <img
        :src="noteIcon"
        alt=""
        aria-hidden="true"
        class="payments-monthly__note-icon"
      >

      <DsText as="body4" class="payments-monthly__note-copy">
        Pagar a tiempo te ayuda a mantener beneficios activos
      </DsText>
    </div>
  </section>
</template>

<script setup lang="ts">
import calendarIcon from '../../../../../assets/calendariopagos.svg'
import noteIcon from '../../../assets/Pagos_lightbulb_circle.svg'
import lateCalendarIcon from '../../../../../assets/nocalendariopagos.svg'
import clockIcon from '../../../../../assets/relojpagos.svg'
import DsChip from '../atoms/DsChip.vue'
import DsText from '../atoms/DsText.vue'
import DsTextSplit from '../atoms/DsTextSplit.vue'
import PaymentsMonthlyCard from './PaymentsMonthlyCard.vue'

const cards = [
  {
    id: 'payment-date',
    iconSrc: calendarIcon,
    title: 'Fecha de pago',
    mobileDescription:
      'Realiza tu pago el día 1 de\ncada mes o el siguiente día\nhábil.',
    tabletDescription:
      'Realiza tu pago el día 1 de cada mes\no el siguiente día hábil.',
    desktopDescription:
      'Realiza tu pago\nel día 1 de cada mes o\nel siguiente día\nhábil.'
  },
  {
    id: 'on-time-payment',
    iconSrc: clockIcon,
    title: 'Pago puntual',
    mobileDescription:
      'Paga antes o el mismo día\nde tu fecha de pago para\nmantener el monto\n' +
      'establecido.',
    tabletDescription:
      'Paga antes o el mismo día de tu fecha de pago para\n' +
      'mantener el monto establecido.',
    desktopDescription:
      'Paga antes o el mismo día\nde tu fecha de pago para\nmantener el monto\n' +
      'establecido.'
  },
  {
    id: 'late-payment',
    iconSrc: lateCalendarIcon,
    title: 'Pago fuera de fecha',
    mobileDescription:
      'Si el pago se realiza después\nde la fecha límite, el monto\n' +
      'puede actualizarse.',
    tabletDescription:
      'Si el pago se realiza después de la fecha límite,\n' +
      'el monto puede actualizarse.',
    desktopDescription:
      'Si el pago se realiza después\nde la fecha límite,\nel monto puede\n' +
      'actualizarse.'
  }
]
</script>

<style scoped>
.payments-monthly {
  display: flex;
  flex-direction: column;
  gap: 16px;
  width: 100%;
}

.payments-monthly__header {
  display: flex;
  flex-direction: column;
  align-items: flex-start;
  gap: 20px;
}

.payments-monthly__header :deep(.ds-chip) {
  padding: 8px;
  color: var(--ds-orange-800);
  background: var(--ds-orange-50);
  font-size: var(--ds-subtitle9-size);
  font-weight: var(--ds-subtitle9-weight);
  line-height: 16px;
}

.payments-monthly__title {
  font-size: var(--ds-h4-size);
  font-weight: var(--ds-h4-weight);
  line-height: 36px;
}

.payments-monthly__title :deep(.ds-text-split__base),
.payments-monthly__title :deep(.ds-text-split__highlight-group) {
  flex-basis: 100%;
}

.payments-monthly__intro {
  max-width: 28ch;
  color: var(--ds-text-primary);
  line-height: 24px;
}

.payments-monthly__cards {
  display: grid;
  grid-template-columns: minmax(0, 1fr);
  gap: 16px;
  width: 100%;
}

.payments-monthly__note {
  display: flex;
  align-items: flex-start;
  gap: 8px;
}

.payments-monthly__note-icon {
  display: block;
  flex: 0 0 20px;
  width: 20px;
  height: 20px;
}

.payments-monthly__note-copy {
  color: var(--ds-text-primary);
  line-height: 20px;
}

@media (min-width: 768px) {
  .payments-monthly {
    gap: 32px;
  }

  .payments-monthly__header {
    gap: 32px;
  }

  .payments-monthly__title :deep(.ds-text-split__base),
  .payments-monthly__title :deep(.ds-text-split__highlight-group) {
    flex-basis: auto;
  }

  .payments-monthly__intro {
    max-width: 48ch;
  }

  .payments-monthly__cards {
    gap: 24px;
  }
}

@media (min-width: 1208px) {
  .payments-monthly {
    gap: 40px;
    max-width: 962px;
    margin-right: auto;
    margin-left: auto;
  }

  .payments-monthly__title {
    font-size: var(--ds-h3-size);
    line-height: 44px;
  }

  .payments-monthly__intro {
    max-width: none;
  }

  .payments-monthly__cards {
    grid-template-columns: repeat(3, minmax(0, 1fr));
    gap: 24px;
  }

  .payments-monthly__note {
    align-items: center;
    justify-content: center;
  }
}
</style>
